var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",class:_vm.type},[_c('div',{staticClass:"bannerleft"}),_c('div',{staticClass:"bannerright",style:(`background-image:url(${_vm.returnImage()})`)}),_c('div',{staticClass:"content fa_text"},[_vm._v(_vm._s(_vm.returnTitle()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }